/**
 * Base entity model. All Apollon models should inherit this class.
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel'
import { BaseCollection } from './BaseCollection'
import dayjs, { Dayjs } from 'dayjs'
import type { MutationsObject } from '@kp/js-model'

export class Team extends BaseModel {
    id: number | null = null
    name: string | null = null
    created: Dayjs | null = null
    modified: Dayjs | null = null
    ersteller_id: number | null = null
    ersteller_name: string | null = null
    anzahl_mitglieder: number | null = null

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            ersteller_id: (ersteller_id) =>
                Number(ersteller_id) > 0 ? Number(ersteller_id) : null,
            anzahl_mitglieder: (anzahl_mitglieder) =>
                Number(anzahl_mitglieder) > 0 ? Number(anzahl_mitglieder) : null,
            created: dayjs,
            modified: dayjs,
        }
    }

    getClassName(): string {
        return 'team'
    }
}

export class TeamCollection extends BaseCollection<Team> {
    protected modelCls = Team

    public getModelClassName(): string {
        return 'team'
    }
}
